import { render, staticRenderFns } from "./ProfileInfos.vue?vue&type=template&id=3108c5c8"
import script from "./ProfileInfos.vue?vue&type=script&lang=js"
export * from "./ProfileInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports